export function stringToDate(string?: string) {
    if (string) {
        return new Date(string.replace(/(\d{2}).(\d{2}).(\d{4})/, "$2/$1/$3"))
    }
    return undefined
}
